import { Component, OnInit, Input, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $;

@Component({
  selector: 'sw-select-multi-box',
  templateUrl: './sw-select-multi-box.component.html',
  styleUrls: ['./sw-select-multi-box.component.css']
})
export class SwSelectMultiBoxComponent implements OnInit {

  constructor(private el: ElementRef,
    private box: SwMassageBoxService,) { }

  ngOnInit() {
  }

  @Input() ids:any;

  @Input() elem:any;

  @Input() dropdown: boolean = true;;

  @Input() height: string = '250px';

  @Input() datas:any=[]

  /**
   * 最多能选择的个数
   */
  @Input() maxSelectNum: number = 0; 

  /**
   * 最多能选择的个数
   */
  @Input() createNewData: boolean = false; 

  /**
   * 是否有搜索框
   */
  @Input() isSearch: boolean = false;
  /**
 * 选中的id
 * @ignore
 */
@Input() selected :any= [];  

/**
 * 选中的文本
 * @ignore
 */
@Input() selectedText = []; 

  /**
   * 搜索框的值
   */
  filter: any;

  /**
   * 输出属性,点击添加'xxx'时，将要新建的数据抛出，业务方接受数据后要创建新标签且且将此新标签选中回填
   */
  @Output() addNewClick = new EventEmitter();

  /**
   * 选中数据
   */
  @Output() changeClick = new EventEmitter();
  @Output() closeSelect = new EventEmitter();

  ngAfterViewInit(): void {
    //如果有搜索框则给焦点
    let postion = this.elem.nativeElement.getBoundingClientRect()
    this.el.nativeElement.style.position = 'fixed';
    this.el.nativeElement.style.zIndex = 9990;
    //this.el.nativeElement.style.top = postion.bottom + 'px';
    this.el.nativeElement.style.left = postion.left + 'px';
    this.el.nativeElement.style.width = postion.width + 'px';

    let height = this.height.split('px')[0]
    let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    let heightAndTop = clientHeight + scrollTop
    if((heightAndTop-postion.bottom)<parseInt(height) ){  //如果输入框下面没有足够的高度，就放上面
      this.el.nativeElement.style.top = postion.top - parseInt(height)  + 'px';
    }else {
      //下方有足够高度，就放下面
      this.el.nativeElement.style.top = postion.bottom + 'px';
    }
    //如果有搜索框则给焦点
    if (this.isSearch == true) {
      setTimeout(() => {
        // 获取input的dom元素
        var search = document.getElementById(this.ids);
        if(search){
          // 自动获取焦点
          search.focus()

        }
      }, 200)
    }

    this.myModalBodyScroll()  //监听 myModalBody 盒子的滚动条事件
    this.myWrapContScroll()  //监听 myWrapCont 盒子的滚动条事件
  }

  ngOnDestroy(): void {
    this.myModalBodyRmScroll()  //移除 myModalBody 盒子的滚动条事件
    this.myWrapContRmScroll()  //移除 myWrapCont 盒子的滚动条事件
  }

    /**
   * 判断是否选中数据
   * @param id  选中的id
   * @ignore
   */
  isChecked(id){
    return this.selected.findIndex(value => value == id) >= 0;
  }

  /**
   * 选中下拉框数据
   * @ignore
   */
  onVoted(e, item){
    const action = this.isChecked(item.id)?'remove':'add';
    this.updateSelected(action,item);
    return false; //阻止事件冒泡而关闭下拉框
  }

  /**
   * 判断点击的数据是新增还是删除 ，做出相对的处理
   * @param action  添加还是删除
   * @param item  选中的数据
   * @ignore
   */
  private updateSelected(action, item){

    //新增添加点击的数据
    if(action == 'add' && this.selected.findIndex(value => value == item.id) == -1){
      //如果有选中标签个数限制，那么在新增的时候，超过个数就不能新增了
      if(this.maxSelectNum && this.selected.length >= this.maxSelectNum){
        this.box.danger('已达到最大选中数')
        return
      }
      this.selected.push(item.id);
      this.selectedText.push(item.text);
    }
    //删除 就删除对应的数据
    if(action == "remove" && this.selected.findIndex(value => value == item.id) != -1){
      this.selectedText.splice(this.selected.findIndex(value => value == item.id), 1);
      this.selected.splice(this.selected.findIndex(value => value == item.id), 1);
    }
    let param = {"action":action,"item":item}
    this.changeClick.emit(param);
  } 


  close(){
    this.closeSelect.emit(false)
  }

  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    //鉴定全屏键盘事件 如果是回车触发
    if(this.mouseo)
        this.closeSelect.emit(false)
  } 

  // //屏幕缩放时
  // @HostListener('window:resize', ['$event']) resize(event) {
  //   /* //屏幕缩放时,下拉框消失,否则下拉框
  //   this.closeSelect.emit(false) */
  //   //屏幕缩放时,重新设置下拉框的位置及宽度
  //   let postion = this.elem.nativeElement.getBoundingClientRect()
  //   this.el.nativeElement.style.top = postion.bottom + 'px';
  //   this.el.nativeElement.style.left = postion.left + 'px';
  //   this.el.nativeElement.style.width = postion.width + 'px';
  // }

  mouseo:boolean = true;
  mouseoverEvent(){
    this.mouseo = false;
  }
  mouseoutEvent(){
    this.mouseo = true;
  }

  //监听 myWrapCont 盒子的滚动条事件,滚动就让日期控件消失
  myWrapContScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myWrapContRmScroll(){
    let _scroll = $("#myWrapCont")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myWrapContScroll)
    }
  }

  //监听 myModalBody 盒子的滚动条事件,滚动就让日期控件消失
  myModalBodyScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll) {
      _scroll.addEventListener('scroll',()=>{
        this.closeSelect.emit(false)
      })
    }
  }

  //页面销毁时,移除此事件
  myModalBodyRmScroll(){
    let _scroll = $("#myModalBody")[0]
    if(_scroll){
      _scroll.removeEventListener('scroll',this.myModalBodyScroll)
    }
  }

  /**
   * 失去焦点
   * @ignore
   */
  Blur() {
    setTimeout(() => {
      // 销毁组件
      this.closeSelect.emit(false)
      
    }, 200);
    event.stopImmediatePropagation();
  }

  //创建新标签
  add(){
    this.addNewClick.emit(this.filter)
    this.closeSelect.emit(false)  //销毁组件
  }

}
